import { render, staticRenderFns } from "./EndGameOverlay.vue?vue&type=template&id=374db87e&scoped=true"
import script from "./EndGameOverlay.vue?vue&type=script&lang=js"
export * from "./EndGameOverlay.vue?vue&type=script&lang=js"
import style0 from "./EndGameOverlay.vue?vue&type=style&index=0&id=374db87e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374db87e",
  null
  
)

export default component.exports